import Vue from 'vue'
import Router from 'vue-router'
import { JsonIsNull } from "../utils/JsonIsNull";
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const main = new Router({
    mode: 'history',
    routes: [{
            path: "*",
            name: '404',
            component: resolve => require(['@/components/404'], resolve),
            meta: {
                title: '404'
            }
        }, {
            path: '/',
            name: 'Home',
            component: resolve => require(['@/components/home'], resolve)
        }, {
            path: '/details',
            name: 'details',
            component: resolve => require(['@/components/details'], resolve)
        }, {
            path: '/login',
            name: 'login',
            component: resolve => require(['@/components/Login'], resolve),
            meta: {
                title: 'login'
            }
        }, {
            path: '/pay',
            name: 'pay',
            component: resolve => require(['@/components/PayShow'], resolve),
            meta: {
                title: 'pay'
            }
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: resolve => require(['@/components/privacy'], resolve),
            meta: {
                title: 'privacy'
            }
        },
        {
            path: '/termsofuse',
            name: 'termsofuse',
            component: resolve => require(['@/components/termsofuse'], resolve),
            meta: {
                title: 'termsofuse'
            }
        },
        {
            path: '/FAQ',
            name: 'FAQ',
            component: resolve => require(['@/components/FAQ'], resolve),
            meta: {
                title: 'FAQ'
            }
        },
        {
            path: '/LegalNotices',
            name: 'LegalNotices',
            component: resolve => require(['@/components/LegalNotices'], resolve),
            meta: {
                title: 'Legal Notices'
            }
        },
        {
            path: '/CookiePreferences',
            name: 'CookiePreferences',
            component: resolve => require(['@/components/CookiePreferences'], resolve),
            meta: {
                title: 'Cookie Preferences'
            }
        },
        {
            path: '/Contactus',
            name: 'Contactus',
            component: resolve => require(['@/components/Contactus'], resolve),
            meta: {
                title: 'Contact us'
            }
        },
        {
            path: '/HelpCenter',
            name: 'HelpCenter',
            component: resolve => require(['@/components/HelpCenter'], resolve),
            meta: {
                title: 'Help Center'
            }
        },
        {
            path: '/signup',
            name: 'signup',
            component: resolve => require(['@/components/signup'], resolve),
            meta: {
                title: 'signup'
            }
        },
        {
            path: '/CorporateInformation',
            name: 'CorporateInformation',
            component: resolve => require(['@/components/CorporateInformation'], resolve),
            meta: {
                title: 'Corporate Information'
            }
        },
        {
            path: '/catalog',
            name: 'catalog',
            component: resolve => require(['@/components/catalog'], resolve),
            meta: {
                title: 'catalog'
            }
        }
    ]
})

main.beforeEach((to, from, next) => {
    const title = to.meta && to.meta.title;
    if (title) {
        document.title = title;
    }
    document.documentElement.scrollTop = 0
    if (to.name === 'details' && !to.query.id) {
        window.location.href = window.location.origin;
        return;
    }
    if (to.name === 'Home' || to.name === 'details' || to.name === 'catalog') {
        localStorage.setItem("path", to.fullPath);
    }
    next();
});
export { main };


// WEBPACK FOOTER //
// ./src/router/index.js